(ns journal-app-client.views.login
  (:require [journal-app-client.utils.common :as common]
            [re-frame.core :as rf]
            [journal-app-client.utils.react :refer [use-state]]
            [journal-app-client.components.logo :refer [app-logo]]
            [journal-app-client.components.button :refer [button link]]
            [journal-app-client.components.input :refer [switch field-input prompt-message validate-user-input]]
            [reagent.core :as r]
            [tick.core :as t]))

(defn login-input [& [props]]
  (let [value (:value (:input-props props))
        active-input? (and value (not (= "" value)))]
    [field-input
     {:control-props    (merge {:field-props {:style {:margin-bottom "0.5rem"
                                                      :width         "100%"
                                                      :min-width "15vw"}}}
                               (:control-props props))
      :input-props      (merge
                          (:input-props props)
                          {:class (or (:class (:input-props props)) " is-info ")})
      :prompt (:prompt props)
      :prompt-props (:prompt-props props)
      :valid-input?     (:valid-input? props)
      :active-input?    active-input?
      :icon-left        (:icon-left props)
      :icon-right       (:icon-right props)
      :icon-right-props (:icon-right-props props)}]))

(defn view-wrapper [& [props]]
  [:div.container.is-fluid
   {:style {:display "flex"
            :justify-content "center"
            :align-items "center"
            :flex-direction "column"}}
   (into
     [:div.box
      {:style {:position       "relative"
               :display        "flex"
               :flex-direction "column"
               :align-items    "center"
               :padding-top    "5rem"
               :max-width      "25rem"}}
      [app-logo
       {:style {:position "absolute"
                :height   "7rem"
                :top      "-3.5rem"}}]]
     (r/children (r/current-component)))])

(defn login-fn [& [props]]
  (let [[state set-state] (use-state {:email "" :password "" :persist-login? false})
        email-input (:email state)
        password-input (:password state)
        show-password? (:show-password? state)
        login-failed? (:login-failed? state)
        loading @(rf/subscribe [:loading])
        login-submit-button-fn (fn [] (rf/dispatch [:login [state set-state]]))]
    (if (:email-sent? state)
      [view-wrapper
       [:h1.title {:style {:text-align "center"}}
        "Email sent"]
       [:p.subtitle {:style {:text-align "center"}}
        [:span {:style {:color "var(--info)"}} (:email state)]
        [:span ". Please check your email."]]
       [link {:on-click #(set-state (dissoc state :email-sent?))}
        [:span "Go back and try again"]
        [:span.icon [:i.fas.fa-rotate-left]]]]
      [view-wrapper
       [login-input
        {:input-props  {:id "email-login-input"
                        :type          "email"
                        :placeholder   "Email"
                        :auto-complete "on"
                        :value         email-input
                        :on-enter-key  login-submit-button-fn
                        :on-change     #(set-state (assoc state
                                                          :email (-> % .-target .-value)
                                                          :login-failed? false))}
         :valid-input? (validate-user-input email-input :email)
         :icon-left    "fas fa-envelope"
         :icon-right   false}]
       #_[login-input
          {:input-props      {:type         (if show-password?
                                              "text"
                                              "password")
                              :placeholder  "Password"
                              :value        password-input
                              :on-enter-key login-submit-button-fn
                              :on-change    #(set-state (assoc state
                                                               :password (-> % .-target .-value)
                                                               :login-failed? false))}
           :icon-left        "fas fa-key"
           :icon-right       (if show-password?
                               "fas fa-eye-slash"
                               "fas fa-eye")
           :icon-right-props {:class    "is-rounded"
                              :style    {:color "var(--blue)"}
                              :on-click #(set-state (assoc state
                                                           :show-password? (not show-password?)
                                                           :login-failed? false))}}]
       [switch
        {:outer-style {:background    "transparent"
                       :padding-left  "0"
                       :padding-right "0"
                       :width         "100%"}
         :checked     (:persist-login? state)
         :on-change   (fn []
                        (set-state (assoc state :persist-login? (not (:persist-login? state)))))}
        "Remember me"]
       [button
        {:class    "is-fullwidth is-primary "
         :style    {:z-index "1"
                    :margin  "1.5rem 0 1.5rem 0"}
         :loading? (:login loading)
         :disabled (not (validate-user-input email-input :email))
         #_(or (not email-input) (= "" email-input)
               (not password-input) (= "" password-input))
         :on-click login-submit-button-fn}
        "Login"]
       #_[prompt-message
          {:show-prompt? login-failed?
           :class        "is-warning "
           :style        {:margin-bottom "0.5rem"}}
          "The username or password is incorrect or you are not validated. Contact IT for more information."]
       [link {:on-click #(rf/dispatch [:select-view :login {:sub-view :login-help}])}
        [:span "Can't log in?"]
        [:span.icon [:i.fas.fa-up-right-from-square]]]
       [link {:on-click #(rf/dispatch [:select-view :home])}
        [:span "Go to home"]
        [:span.icon [:i.fas.fa-up-right-from-square]]]
       #_[link {:on-click #(rf/dispatch [:select-view :login {:sub-view :sign-up}])}
        [:span "Sign up"]
        [:span.icon [:i.fas.fa-up-right-from-square]]]])))

(def input-component-data
  [{:path                [:email]
    :text                "Email"
    :icon-left   "fas fa-envelope"
    :prompt              "Email is not valid or it is in use already"
    :validate-user-input (fn [s users]
                           (and (empty? (filter #(= (:email (second %)) s) users))
                                (validate-user-input s :email)))
    :required?           true}
   #_{:path      [:password]
    :text      "Password"
    :icon-left        "fas fa-key"
    :input-type "password"
    :required? true}
   {:path                [:username]
    :text                "Username"
    :label               "Username"
    :help-text           "Username is what is visible in the app"
    :icon-left   "fas fa-user"
    :prompt              "Username invalid or is already in use"
    :validate-user-input (fn [s users]
                           (and (not (= s "")) (empty? (filter #(= (:username (second %)) s) users))))
    :required?           true}
   {:path      [:information :first-name]
    :text      "First name"}
   {:path      [:information :middle-name]
    :text      "Middle name"}
   {:path      [:information :last-name]
    :text      "Last name"}])

(defn sign-up-fn [& [props]]
  (let [[state set-state] (use-state {})
        [db-updates set-db-updates] (use-state {})
        loading @(rf/subscribe [:loading])
        all-users nil
        can-create-user? (empty? (filter #(and (:required? %)
                                               (if (fn? (:validate-user-input %))
                                                 (if (get-in db-updates (:path %))
                                                   (not ((:validate-user-input %) (get-in db-updates (:path %)) all-users))
                                                   true)
                                                 (not (get-in db-updates (:path %)))))
                                         input-component-data))]
    (into
      (into
        [view-wrapper
         [:h1.title {:style {:text-align "center"}}
          (cond (= (:status props) :success)
                "Sign up successful"
                (= (:status props) :failure)
                "Something went wrong..."
                :else
            "Create new user")]]
        (if (:status props)
          [[:p.subtitle {:style {:text-align "center"}}
            (cond (= (:status props) :success)
                  "Please wait until IT validates your sign up"
                  (= (:status props) :failure)
                  "If this persists, please contact IT"
                  :else nil)]]
          (map-indexed
            (fn [index component-data]
              (let [valid-input? (if (fn? (:validate-user-input component-data))
                                   (when (get-in db-updates (:path component-data))
                                     ((:validate-user-input component-data)
                                      (get-in db-updates (:path component-data)) all-users))
                                   (get-in db-updates (:path component-data)))]
                [login-input
                 {:key              (str "sign-up-input-fields" index)
                  :input-props      {:type        (if (= "password" (:input-type component-data))
                                                    (if (:show-password? state)
                                                      "text"
                                                      "password")
                                                    "text")
                                     :class       (cond valid-input?
                                                        "is-success"
                                                        (false? valid-input?)
                                                        "is-danger"
                                                        (and (not (get-in db-updates (:path component-data)))
                                                             (:required? component-data))
                                                        "is-info"
                                                        :else
                                                        "")
                                     :placeholder (:text component-data)
                                     :value       (get-in db-updates (:path component-data))
                                     :auto-focus  (when (= index 0) true)
                                     :max-length  (:input-max-length component-data)
                                     :on-change   (fn [event]
                                                    (set-db-updates (assoc-in db-updates (:path component-data)
                                                                              (-> event .-target .-value))))}
                  :prompt           (:prompt component-data)
                  :prompt-props     (when (:prompt component-data) {:show-prompt? (false? valid-input?)})
                  :valid-input?     valid-input?
                  :icon-left        (:icon-left component-data)
                  :icon-right       (if (= "password" (:input-type component-data))
                                      (if (:show-password? state)
                                        "fas fa-eye-slash"
                                        "fas fa-eye")
                                      false)
                  :icon-right-props {:class    "is-rounded"
                                     :style    {:color "var(--blue)"}
                                     :on-click #(set-state (assoc state :show-password? (not (:show-password? state))))}}]))
            input-component-data)))
      [[:div
        {:style {:overflow   "auto"
                 :display    "flex"
                 :flex-wrap  "wrap"
                 :margin-top "1rem"
                 :position   "sticky"
                 :z-index    2
                 :bottom     "0"}}
        [button
         {:style    {:flex      1
                     :margin    "0.25rem"
                     :min-width "10rem"}
          :on-click #(rf/dispatch [:select-view :login])}
         (if (= :success (:status props)) "Ok" "Cancel")]
        (when-not (= :success (:status props))
          [button
           (merge
             {:class "is-success is-outlined"
              :style {:flex      1
                      :margin    "0.25rem"
                      :min-width "10rem"}
              :on-click #(rf/dispatch [:select-view :login {:sub-view :sign-up}])}
             (when-not (:status props)
               {:disabled (not can-create-user?)
                :loading? (:patch! loading)
                :on-click (fn [])}))
           (if (= :failure (:status props)) "Try again" "Confirm")])]])))

(defn login-help [& [props]]
  [:div.container.is-fluid
   {:style {:display             "flex"
            :justify-content     "center"
            :align-items         "center"
            :flex-direction      "column"}}
   [app-logo
    {:style {:height "7rem"
             :margin "1.5rem"}}]
   [:h1.title
    {:style {:max-width  "50rem"
             :text-align "center"}}
    "Can't log in?"]
   [:p.subtitle
    {:style {:max-width  "50rem"
             :text-align "center"}}
    "There may be many reasons for why you can't log in. Here are some options"]
   [:div
    {:style {:display         "flex"
             :flex-wrap       "wrap"
             :justify-content "center"}}
    [button
     {:class    "is-large"
      :style    {:flex-direction "column"
                 :height         "12rem"
                 :width          "12rem"
                 :margin         "1rem"}
      :on-click #(rf/dispatch [:select-view :login {:sub-view :forgot-password}])}
     [:span.icon
      {:style {:font-size "3.5rem"
               :margin    "0"}}
      [:i.fas.fa-key]]
     [:span {:style {:white-space "break-spaces"}}
      "Forgot password"]]
    [button
     {:class    "is-large"
      :style    {:flex-direction "column"
                 :height         "12rem"
                 :width          "12rem"
                 :margin         "1rem"}
      :on-click #(rf/dispatch [:select-view :login {:sub-view :forgot-email}])}
     [:span.icon
      {:style {:font-size "3.5rem"
               :margin    "0"}}
      [:i.fas.fa-user]]
     [:span {:style {:white-space "break-spaces"}}
      "Forgot email address"]]
    #_[button
     {:class    "is-large"
      :style    {:flex-direction "column"
                 :height         "12rem"
                 :width          "12rem"
                 :margin         "1rem"}
      :on-click #(rf/dispatch [:select-view :login {:sub-view :sign-up}])}
     [:span.icon
      {:style {:font-size "3.5rem"
               :margin    "0"}}
      [:i.fas.fa-user-plus]]
     [:span {:style {:white-space "break-spaces"}}
      "Sign up"]]]])

(defn forgot-password [& [props]]
  [:div.container.is-fluid
   {:style {:display             "flex"
            :justify-content     "center"
            :align-items         "center"
            :flex-direction      "column"}}
   [app-logo
    {:style {:height "7rem"
             :margin "1.5rem"}}]
   [:h1.title
    {:style {:max-width  "50rem"
             :text-align "center"}}
    "Password recovery"]
   [:p.subtitle
    {:style {:max-width  "50rem"
             :text-align "center"}}
    "Contact IT for further help regarding password recovery"]
   [link {:on-click #(rf/dispatch [:select-view :login])}
    [:span "Go back"]
    [:span.icon [:i.fas.fa-rotate-left]]]])

(defn forgot-email [& [props]]
  [:div.container.is-fluid
   {:style {:display             "flex"
            :justify-content     "center"
            :align-items         "center"
            :flex-direction      "column"}}
   [app-logo
    {:style {:height "7rem"
             :margin "1.5rem"}}]
   [:h1.title
    {:style {:max-width  "50rem"
             :text-align "center"}}
    "Email recovery"]
   [:p.subtitle
    {:style {:max-width  "50rem"
             :text-align "center"}}
    "Contact IT for further help regarding password recovery"]
   [link {:on-click #(rf/dispatch [:select-view :login])}
    [:span "Go back"]
    [:span.icon [:i.fas.fa-rotate-left]]]])

(defn view [& [props]]
  (case (:sub-view props)
    :login-help [login-help props]
    :sign-up [:f> sign-up-fn props]
    :forgot-email [forgot-email props]
    :forgot-password [forgot-password props]
    [:f> login-fn props]))
